import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import CookieSection from './components/CookieSection';
import ProductsSection from './components/ProductsSection';
import PromoSection from './components/PromoSection';
import Footer from './components/Footer';
import CookieConsentBar from './components/CookieConsentBar';
import Admin from './pages/Admin';

function HomePage() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="w-full bg-white min-h-screen">
      <div className="relative w-full mx-auto">
        <Hero reloadPage={reloadPage} />
        <CookieSection />
        <ProductsSection />
        <PromoSection />
        <Footer scrollToTop={scrollToTop} reloadPage={reloadPage} />
      </div>
      <CookieConsentBar />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </Router>
  );
}

export default App;
